import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./styles.scss";

const InputPassword = ({
  name,
  className = "",
  value,
  onChange,
  placeholder,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <div className="input-password" style={{ position: "relative" }}>
      <input
        name={name}
        className={`styled-input ${className}`}
        value={value}
        onChange={(e) => onChange(e)}
        placeholder={placeholder}
        type={isPasswordVisible ? "text" : "password"}
        style={{ paddingRight: "30px" }} // Espaço para o ícone
      />
      <span
        onClick={togglePasswordVisibility}
        className="icon-password"
      >
        <FontAwesomeIcon icon={isPasswordVisible ? faEyeSlash : faEye} />
      </span>
    </div>
  );
};

export default InputPassword;
